export default () => {
    $(window).scroll(function(){
        var scrollPos = $(document).scrollTop();
        var headerHeight = $('header.site-header').outerHeight();

        if (scrollPos > headerHeight / 2 ) {
            $('header.site-header').removeClass('impact')
        } else {
            $('header.site-header').addClass('impact')
        }
    });
}